/**
 * Get the public URL path prefix (e.g., '/v2' or '')
 * This is used to prefix paths for assets when the app is deployed in a subdirectory
 */
export const getPublicPath = () => {
  return process.env.PUBLIC_URL || '';
};

/**
 * Get the full path for an image in the public/images folder
 * @param {string} imagePath - Path relative to public folder (e.g., '/images/photo.jpg')
 * @returns {string} - Full path with PUBLIC_URL prefix (e.g., '/v2/images/photo.jpg')
 */
export const getImagePath = (imagePath) => {
  const publicPath = getPublicPath();
  // Ensure imagePath starts with /
  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${publicPath}${normalizedPath}`;
};

